import { redirect } from "@tanstack/react-router";

const AUTH_KEY = "auth";

export function setAuth(data: any) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(data));
}

export function getAuth() {
  try {
    return JSON.parse(localStorage.getItem("auth") || "null");
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
}

export function requireAuth() {
  const auth = getAuth();

  if (!auth?.token) {
    throw redirect({ to: "/" });
  }

  return auth;
}

export function requireRole(role: "ADMIN" | "USER") {
  const auth = requireAuth();

  if (auth.user.role !== role) {
    throw redirect({ to: "/" });
  }

  return auth;
}
